// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_4p-0";
export var orangeButton = "_4p-1";